<template>
  <div>
    <el-button v-if="showBack" size="mini" type="primary" @click="back">返回</el-button>


    <el-input v-model="searchInput" placeholder="请输入搜索关键词"
              style="width: 300px; margin-bottom: 10px;margin-left: 10px"></el-input>
    <el-table :data="filteredConfigList">
      <el-table-column align="center" label="文件名称" prop="name" width="300px"></el-table-column>
      <el-table-column align="center" label="路径" prop="location"></el-table-column>
      <el-table-column align="center" label="版本号" prop="version"></el-table-column>
      <el-table-column align="center" label="描述" prop="function" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column align="center" label="创建者" prop="creator"></el-table-column>
      <el-table-column align="center" label="操作"  min-width="400px">
        <template v-slot="{ row }">
          <span v-if="row.isDir">
            <el-button size="mini" type="primary" @click="enter(row.location, true)"
                       v-if="btnInList('instanceList_panel_configList') || btnInList('instance_configList')">进入</el-button>
          </span>
          <span v-else>
            <el-button size="mini" type="primary" v-if="btnInList('view')"
                       @click="configDetail(row, 'cat')">查看</el-button>
            <!--            <el-button size="mini" type="primary" v-if="btnInList('config_edit')"-->
            <!--                       @click="configDetail(row,'edit')">编辑</el-button>-->
            <el-button size="mini" type="primary" v-if="type == 1 && btnInList('compare')" @click="historyCompare(row)">历史版本对比</el-button>

            <el-dropdown style="margin-left: 10px;margin-right: 10px" @command="configDetailSH"
                         v-if="btnInList('helper') && displayByType">
              <el-button type="primary" size="mini">
                helper查看
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ row: row, charset: 'UTF-8' }">UTF-8</el-dropdown-item>
                <el-dropdown-item :command="{ row: row, charset: 'GB2312' }">GB2312</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!--            <a v-if="!row.isDefault && type!='2' && type != 'modulelist'" style="margin-left: 10px;"-->
            <!--              :href=" instanceid ? (baseUrl+'config/download/'+currentModule.name+'/'+currentModule.version + '/' + instanceid+'/'+row.name+'/'+ encodeURIComponent(row.location)) : (moduleUrl+'config/download/'+currentModule.name+'/'+currentModule.version +'/'+row.name+'/'+encodeURIComponent(row.location))">-->
            <!--              <el-button size="mini" type="primary">下载</el-button>-->
            <!--            </a> -->
            <!-- <a v-if="type != '2' && btnInList('download')" style="margin-left: 10px;"
              :href="docker ?
                (instanceid ? (configDownload(row)) : (moduleUrl + 'config/download/' + currentModule.name + '/' + currentModule.version + '/' + row.name + '/' + encodeURIComponent(encodeURIComponent(allLocation))))
                :
                (instanceid ? (configDownload(row)) : (moduleUrl + 'config/download/' + currentModule.name + '/' + currentModule.version + '/' + row.name + '/' + encodeURIComponent(encodeURIComponent(row.location))))"> -->
            <el-button size="mini" type="primary" v-if="type != '2' && btnInList('download')"
                       @click='download(row)'>下载</el-button>
            <!-- </a> -->
            <!--             :href=" instanceid ? (baseUrl+'config/download/'+currentModule.name+'/'+currentModule.version + '/' + instanceid+'/'+row.name+'/'+ encodeURIComponent(row.location)) : (moduleUrl+'config/download/'+currentModule.name+'/'+currentModule.version +'/'+row.name+'/'+encodeURIComponent(row.location))">-->

            <!-- <el-button size="mini" type="primary" @click="downloadFile(row)" v-if="type!='2' &&btnInList('display')">下载</el-button> -->
            <!-- <el-upload
              v-if="!row.isDefault && type!='2' && type != 'modulelist'"
              style="display: inline-block;margin: 0 10px;"
              ref="upload"
              :on-success="handleSuccess"
              :on-error="handleError"
              :action="instanceid ? (baseUrl+'config/upload/ins/config') : (baseUrl+'instance/upload/config')"
              :show-file-list="false"
              name="filePart"
              :data="instanceid ? {
                configName: row.name,
                location: row.location,
                instanceId: instanceid,
                moduleName: currentModule.name,
                moduleVersion: currentModule.version
              } : {moduleType: currentModule.name, name:row.name, version: row.version}"
            >
              <el-button size="mini" type="primary" @click="upload(row)">上传</el-button>
            </el-upload> -->
            <el-upload v-if="type != '2' && type != 'modulelist'"
                       style="display: inline-block;margin: 0 10px;" ref="upload" :on-success="handleSuccess"
                       :on-error="handleError"
                       :action="instanceid ? (baseUrl3 + 'config/upload/ins/config') : (baseUrl3 + 'instance/upload/config')"
                       :show-file-list="false" name="filePart" :data="instanceid ? {
                configName: row.name,
                location: docker ? (allLocation+'') : (row.location+''),
                instanceId: instanceid,
                moduleName: currentModule.name,
                moduleVersion: currentModule.version
              } : { moduleType: currentModule.name, name: row.name, version: row.version }" :headers="{
                Authorization: 'Bearer ' + token
              }">
              <el-button size="mini" type="primary" v-if="btnInList('upload')" @click="upload(row)">上传</el-button>
            </el-upload>
            <!-- <el-button size="mini" v-if="type=='2' && instanceid" type="primary" @click="reverseSync( row)">反向同步</el-button> -->
            <el-button size="mini" v-if="type == '2' && instanceid && btnInList('reverseSync')" type="primary"
                       @click="reverseSync(row)">反向同步
            </el-button>
            <!-- <el-dropdown v-if="type=='1' && instanceid" >
                <el-button type="primary" size="mini">
                  同步
                  <i class="el-icon-arrow-down el-icon-right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button type="primary" size="mini" @click="hotLoading(row)">热加载</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button type="primary" size="mini" @click="coldLoading(row)">冷加载</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
            <el-dropdown v-if="type == '1' && instanceid && btnInList('sync')">
              <el-button type="primary" size="mini">
                同步
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button type="primary" size="mini" @click="hotLoading(row)">热加载</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="primary" size="mini" @click="coldLoading(row)">冷加载</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :title="fileName" :visible.sync="xmlDialogVisible" width="80%" center append-to-body>
      <pre style="white-space: pre-wrap;">{{ xmlContentText }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="xmlDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="fileName" :visible.sync="xmlShow" width="75%" center v-if="xmlShow" append-to-body>
      <div>
        <el-form>
          <el-form-item label="文件格式：">
            <el-radio-group size="mini" v-model="fileForm.format" @change="changeMode(fileForm.format)">
              <el-radio border label="yml" style="margin-right: 1px;"></el-radio>
              <el-radio border label="xml" style="margin-right: 1px;"></el-radio>
              <el-radio border label="bat" style="margin-right: 1px;"></el-radio>
              <el-radio border label="sh" style="margin-right: 1px;"></el-radio>
              <el-radio border label="properties" style="margin-right: 1px;"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="文件内容：">
            <div class="code-mirror" style="margin-left: 80px;">
              <textarea ref="textarea"/>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
<!--        从远端获取配置文件时，不显示保存按钮，从管理中心获取配置文件时才显示保存按钮-->
        <el-button type="primary" @click="isSave"
                   v-if="type !=2 && (btnInList('instanceList_more_configList_view_edit') || btnInList('instanceList_panel_configList_view_edit') || btnInList('instance_configList_view_edit'))">保 存</el-button>
        <el-button type="primary" @click="xmlShow = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="历史版本对比" v-if="history" :visible.sync="history" width="80%" center append-to-body>
      <div>
        <el-form>
          <el-form-item label="文件格式：">
            <el-radio-group size="mini" v-model="fileForm.format">
              <el-radio border label="yml" style="margin-right: 1px;"></el-radio>
              <el-radio border label="xml" style="margin-right: 1px;"></el-radio>
              <el-radio border label="bat" style="margin-right: 1px;"></el-radio>
              <el-radio border label="sh" style="margin-right: 1px;"></el-radio>
              <el-radio border label="properties" style="margin-right: 1px;"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-dropdown trigger="click" @command="selectVersion">
            <el-button type="primary" size="mini" style="float:right;margin-left: 800px;margin-top:-10px">
              选择历史版本
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="history" style="height: 100px;overflow-y: scroll;">
              <el-dropdown-item :command="item" v-for="(item, index) in historyVersionData" :key="index">
                <div v-if="selectedVersion == item.version"><img style="width:20px;height: 20px;margin: -5px 0px;"
                                                                 src="@/assets/select.png"/>
                  {{ item.name }}
                </div>
                <div v-else :title="'版本号:' + item.version">{{ item.name }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-form-item label="">
            <div>
              <div v-if="totalChange != 0" style="font-size: 20px;color: #ff3538;">
                共有{{ totalChange }}处不同
                <el-button type="primary" size="mini" style="margin-left: 10px" @click="nextDiff">下一处</el-button>
              </div>

              <span style="font-size: 15px">当前版本:</span>
              <span style="font-size: 15px;margin-left: 500px;">历史版本:
                <span v-if="selectedVersion"
                      style="font-size: 10px;margin-left: 500px;margin-top:-30px;float: right">版本号：{{
                    selectedVersion
                  }}</span>
              </span>
            </div>
            <div id="view" ref="myCodemirror" style="margin-top: 5px">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savehistoryFile"
                   v-if="btnInList('instance_configList_view_edit')">保存</el-button>
        <el-button type="primary" @click="history = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CodeMirror from 'codemirror'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/yaml-lint'
import 'codemirror/addon/lint/json-lint'

// 代码折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/xml-fold.js'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
//搜索功能
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/addon/search/jump-to-line.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/mode/css/css.js'
import {Loading} from "element-ui";
import {mapState} from 'vuex';

//代码版本差异比较
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import DiffMatchPatch from 'diff-match-patch'
import 'codemirror/addon/display/autorefresh'

window.jsyaml = require('js-yaml'); // 引入js-yaml为codemirror提高语法检查核心支持

window.diff_match_patch = DiffMatchPatch;
window.DIFF_DELETE = -1;
window.DIFF_INSERT = 1;
window.DIFF_EQUAL = 0;

export default {
  name: "ConfigList",
  props: {
    moduleInfo: {
      type: Object,
      default: {}
    },
    instanceid: {
      type: [String, Number]
    },
    docker: {
      type: Boolean,
    },
    serviceName: {
      type: String,
    },
    // 1.管理中心 2.远端
    type: {
      type: String
    },
    start: {
      type: Number
    },
    // 是否根据查看类型显示
    displayByType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchInput: "",
      // isShow:false,
      options: {
        mode: 'javascript',
      },
      totalDiff: 0,
      selectedVersion: '',
      selectedName: '',
      selected: false,
      isDir: false,
      showBack: false,
      modes: [
        {
          value: 'javascript',
          label: 'Javascript'
        }, {
          value: 'html',
          label: 'XML/HTML'
        }, {
          value: 'x-swift',
          label: 'Swift'
        }, {
          value: 'x-vue',
          label: 'Vue'
        }],
      nowCode: "",
      anothercode: "",
      fileForm: {
        format: ""
      },
      xmlDialogVisible: false,
      xmlContentText: '',
      history: false,
      historyVersionData: [],
      configList: [], //配置文件列表
      currentModule: {}, //当前的模块
      xmlShow: false,
      yamlEditor: {},
      yamlleftEditor: {},
      yamlrightEditor: {},
      fileName: "",
      saveLocation: "",
      xmlContent: "",
      configs: [], //上传文件信息列表
      currentXml: {},
      textContent: '',
      lineName: "",
      lineLocation: "",
      totalChange: null,
      locationList: [],
      allLocation: ''
    }
  },
  watch: {
    moduleInfo: {
      handler(newVal, oldVal) {
        this.currentModule = newVal;
        this.getConfigList();
      },
      deep: true
    },
    xmlContent(value) {
      const editorValue = this.yamlEditor.getValue();
      if (value !== editorValue) {
        this.yamlEditor.setValue(this.xmlContent)
      }
    },
    yamlleftEditor: {
      handler() {
        this.totalChange = this.yamlleftEditor.right.chunks.length;
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['menus', 'listOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn.some(childOp => childOp.name.includes(childName))
        }
      }
    },
    token() {
      return localStorage.getItem('token')
    },
    filteredConfigList() {
      return this.configList.filter(item => {
        const query = this.searchInput.toLowerCase();
        return item.name.toLowerCase().includes(query)
      });
    }
  },
  created() {
    this.currentModule = this.moduleInfo;
    this.getConfigList();
  },
  methods: {
    nextDiff() {
      if (this.yamlleftEditor.right.chunks.length > 0) {
        let t = this.yamlleftEditor.edit.charCoords({
          line: this.yamlleftEditor.right.chunks[this.totalDiff].editTo,
          ch: 0
        }, "local").top;
        let middleHeight = this.yamlleftEditor.edit.getScrollerElement().offsetHeight / 2;
        this.yamlleftEditor.edit.scrollTo(null, t - middleHeight - 5);
        this.totalDiff += 1;
        if (this.totalDiff == this.yamlleftEditor.right.chunks.length) {
          this.$message.error("已经到底了哦!");
          this.totalDiff = 0;
        }
      }
    },
    changeMode(val) {
      // 修改编辑器的语法配置
      this.yamlEditor.setOption('mode', `text/${val}`);
      this.yamlEditor.setValue('');
      this.yamlEditor.setValue(this.xmlContent);
    },
    jiequ() {
      this.fileForm.format = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
      if (this.fileForm.format == 'yml' || this.fileForm.format == 'yaml') {
        this.fileForm.format = 'yml';
      }
    },
    historyCompare(row) {
      this.history = true;
      this.historyconfigDetail(row);
      this.historyVersion(row);
    },
    initUI(value, orig) {
      if (value == null) return;
      let target = document.getElementById("view");
      target.innerHTML = "";
      this.yamlleftEditor = CodeMirror.MergeView(target, {
        autorefresh: true,
        value: this.nowCode,//上次内容
        origLeft: null,
        orig: this.anothercode,//本次内容
        lineNumbers: true,//显示行号
        mode: "shell",
        highlightDifferences: true,
        styleActiveLine: true,
        matchBrackets: true,
        connect: 'align',
        readOnly: false,//是否只读
      });
      this.yamlleftEditor.edit.doc.setValue(this.nowCode);
    },
    initYaml() {
      setTimeout(() => {
        let _this = this;
        _this.yamlEditor = null;
        _this.yamlEditor = CodeMirror.fromTextArea(_this.$refs.textarea, {
          lineNumbers: true,  // 显示行号
          mode: 'text/x-yaml',  // 语法model
          // theme: 'monokai',  // 编辑器主题
          lint: true, //开启语法检查,
          foldGutter: true,
          lineWrapping: true,
          gutters: [
            'CodeMirror-lint-markers',
            'CodeMirror-foldgutter',
            'CodeMirror-linenumbers'
          ],  // 语法检查器
        });
        this.xmlContent = this.textContent;
        // this.yamlEditor.setValue("");
        this.yamlEditor.setSize('100%', '100%');//设置代码框的长宽
        this.yamlEditor.setValue(this.xmlContent);
        this.yamlEditor.on('change', (cm) => {
          this.$emit('changed', cm.getValue());
          this.$emit('input', cm.getValue());
        })
      }, 0);
    },
    getValue() {
      return this.ConfigList.getValue()
    },
    back() {
      if (this.locationList.length > 1) {
        this.locationList.pop();
        this.enter(this.locationList.pop(), false)
      } else {
        this.showBack = false;
        this.locationList = [];
        this.locationList.push("");
        this.enterDockerConfigList()
      }
    },
    enter(location) {
      this.showBack = true;
      let param = "";
      this.locationList.push(location);
      this.locationList.forEach(d => {
        param = param + d + '/'
      });
      let path;
      if (this.locationList.length == 1) {
        path = location
      } else {
        path = param
      }
      this.allLocation = path;
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.configList = [];
      let url = this.baseUrl3 + "config/cat/list"
      //  + this.instanceid + "/" + encodeURIComponent(encodeURIComponent(path));
      let data = {
        instanceId: this.instanceid,
        path: path
      }

      this.$axios.post(url, data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              data.forEach(d => {
                if (!d.location) {
                  d.location = null
                }
              });
              this.configList = data;
            } else {
              this.$message({showClose: true, message: "当前模块没有配置文件", type: "warn"});
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    enterDockerConfigList() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.configList = [];
      let url = this.baseUrl3 + "config/cat/list"
      // + this.instanceid + "/" + null;
      let data = {
        instanceId: this.instanceid,
        path: 'null'
      }
      this.$axios.post(url, data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              data.forEach(d => {
                if (!d.location) {
                  d.location = null
                }
              });
              this.configList = data;
              this.locationList = [];
              this.allLocation = null
            } else {
              this.$message({showClose: true, message: "当前模块没有配置文件", type: "warn"});
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    getConfigList() {
      //非docker调仓库
      debugger
      if (this.docker == true) {
        this.enterDockerConfigList();
      } else {
        this.getAllConfigList()
      }
    },
    getAllConfigList() {
      if (!this.currentModule.name || !this.currentModule.version) {
        return;
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.configList = [];
      debugger
      this.$axios
        .get(
          this.moduleUrl +
          "config/get/listByNameAndVersion/" +
          this.currentModule.name +
          "/" +
          this.currentModule.version
        )

        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
              if (d.name.indexOf(".service") != -1) {
                d.name = this.serviceName + ".service";
              }
            });
            this.configList = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    setDefault(row) {
      // row.isDefault = !row.isDefault
      this.$set(row, "isDefault", !row.isDefault);
    },
    download(row) {
      if (this.instanceid) {
        this.configDownload(row)
      } else {
        this.moduleConfigDownload(row)
      }
    },
    moduleConfigDownload(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let path = ''
      if (this.docker) {
        path = this.allLocation
      } else {
        path = row.location
      }
      let url = this.moduleUrl + 'config/download/' + currentModule.name + '/' + currentModule.version + '/' + row.name + '/' + encodeURIComponent(encodeURIComponent(path))
      this.$axios.get(url, {
        responseType: 'blob' // 设置响应类型为blob
      })
        .then(function (response) {
          // 创建一个Blob对象
          const blob = new Blob([response.data], {type: response.headers['content-type']}); // 根据文件类型设置MIME类型
          // 创建一个下载链接
          const url = window.URL.createObjectURL(blob);
          // 创建一个a标签并设置属性以开始下载
          const a = document.createElement('a');
          a.href = url;
          // content-disposition必须为小写
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'default_filename.zip'; // 默认文件名
          if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches.length > 1) {
              filename = matches[1];
            }
          }
          a.download = filename; // 设置下载文件的名称
          // 将a标签添加到DOM中并模拟点击以开始下载
          document.body.appendChild(a);
          a.click();
          // 清理DOM
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error); // 处理错误情况
        });
    },
    configDownload(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      let path = ''
      if (this.docker) {
        path = this.allLocation
      } else {
        path = row.location
      }

      let url = this.baseUrl3 + 'config/local/download'
      //+ currentModule.name + '/' + currentModule.version + '/' + instanceid + '/' + row.name + '/' + encodeURIComponent(encodeURIComponent(allLocation))
      let data = {
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        instanceId: this.instanceid,
        configName: row.name,
        location: path+''
      }
      this.$axios.post(url, data, {
        responseType: 'blob' // 设置响应类型为blob
      })
        .then(function (response) {
          // 创建一个Blob对象
          const blob = new Blob([response.data], {type: response.headers['content-type']}); // 根据文件类型设置MIME类型
          // 创建一个下载链接
          const url = window.URL.createObjectURL(blob);
          // 创建一个a标签并设置属性以开始下载
          const a = document.createElement('a');
          a.href = url;
          // content-disposition必须为小写
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'default_filename'; // 默认文件名
          if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches && matches.length > 1) {
              filename = matches[1];
            }
          }
          a.download = filename; // 设置下载文件的名称
          // 将a标签添加到DOM中并模拟点击以开始下载
          document.body.appendChild(a);
          a.click();
          // 清理DOM
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error); // 处理错误情况
        });

    },
    // 配置文件详情
    historyconfigDetail(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = row.location
      }
      const arg =
        this.currentModule.name +
        "/" +
        this.currentModule.version +
        "/" +
        row.name +
        "/" +
        encodeURIComponent(encodeURIComponent(path));

      let url = this.moduleUrl + "config/cat/" + arg;
      if (this.instanceid) {
        this.historyconfigDetailPost(row, path)
      } else {
        this.$axios.get(url)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.anothercode = "";
              this.selectedVersion = "";
              this.fileName = row.name;
              this.jiequ();
              this.saveLocation = row.location;
              this.nowCode = data;
              this.$nextTick(function () {
                this.initUI(this.nowCode, this.anothercode)
              });
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            loading.close()
          }).catch(err => {
          loading.close();
          console.log(err)
        });
      }
    },
    historyconfigDetailPost(row, path) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // url = this.baseUrl + 'config/cat/' + this.currentModule.name + "/"
      //   + this.currentModule.version + "/" + this.instanceid + '/'
      //   + row.name + "/" + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + 'config/cat/content'

      let data = {
        instanceId: this.instanceid,
        configName: row.name,
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        location: path+""
      }
      //远端
      if (this.type == '2') {
        url = this.baseUrl3 + 'config/cat/remote/content'
        // + this.instanceid + '/'
        //   + row.name + "/" + encodeURIComponent(encodeURIComponent(path))
        data = {
          instanceId: this.instanceid,
          configName: row.name,
          location: path+""
        }
      }
      this.$axios.post(url, data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.anothercode = "";
            this.selectedVersion = "";
            this.fileName = row.name;
            this.jiequ();
            this.saveLocation = row.location;
            this.nowCode = data;
            this.$nextTick(function () {
              this.initUI(this.nowCode, this.anothercode)
            });
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
        loading.close();
        console.log(err)
      });
    },
    //历史版本-保存
    savehistoryFile() {
      let _location = null;
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = this.saveLocation
      }

      if (path) {
        _location = path
      }
      let data = {
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        instanceId: this.instanceid,
        configName: this.fileName,
        location: _location+"",
        content: this.yamlleftEditor.edit.doc.getValue()
      };

      this.$axios.post(this.baseUrl3 + 'management3/config/update', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.history = false;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //查看后保存
    isSave() {
      let _location = null;
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = this.saveLocation
      }
      if (path) {
        _location = path
      }
      let obj = {
        location: _location+"",
        name: this.fileName
      }
      if (this.type == 1) {
        this.saveFile(_location);
      } else if (this.type == 2) {
        this.saveFile(_location);
        this.coldLoading(obj);
      } else {
        this.saveFile(_location);
      }
    },
    saveFile(_location) {
      let data = {
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        instanceId: this.instanceid,
        configName: this.fileName,
        location: _location+"",
        content: this.yamlEditor.getValue(),
      };
      this.$axios.post(this.baseUrl3 + 'management3/config/update', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.xmlShow = false;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //查询历史版本
    historyVersion(row) {
      let _location;
      if (this.docker) {
        _location = this.allLocation
      } else {
        _location = row.location
      }
      if (_location) {
        _location = encodeURIComponent(encodeURIComponent(_location))
      }
      // let loading = Loading.service({
      //   fullscreen: true,
      //   text: "数据加载中..."
      // });
      // const arg =
      //   this.currentModule.name +
      //   "/" +
      //   this.currentModule.version +
      //   "/" +
      //   row.name +
      //   "/" +
      //   _location;
      // let url = this.baseUrl3 + "config/cat/list";
      // let data = {
      //   instanceId: this.instanceid,
      //   path: _location
      // }
      if (this.instanceid) {
        this.historyVersionPost(row, _location)
      }
      // this.$axios.post(url,data).then(({data: {msg, data, code}}) => {
      //   if (code == 20000) {
      //     this.historyVersionData = data;
      //   } else {
      //     this.$message({showClose: true, message: msg, type: "error"});
      //     console.log(msg);
      //   }
      //   loading.close()
      // }).catch(err => {
      //   loading.close();
      //   console.log(err)
      // });
    },
    historyVersionPost(row, _location) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      let url = this.baseUrl3 + 'config/history/list'
      //  + this.currentModule.name + "/" + this.currentModule.version + "/" + this.instanceid + '/'+ row.name + "/" + _location;
      let data = {
        instanceId: this.instanceid,
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        configName: row.name,
        location: _location+""
      }
      this.$axios.post(url, data).then(({data: {msg, data, code}}) => {
        if (code == 20000) {
          this.historyVersionData = data;
        } else {
          this.$message({showClose: true, message: msg, type: "error"});
          console.log(msg);
        }
        loading.close()
      }).catch(err => {
        loading.close();
        console.log(err)
      });

    },
    selectVersion(row) {
      this.selectedVersion = row.version;
      let _location = null;
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = this.saveLocation
      }
      if (path) {
        _location = encodeURIComponent(encodeURIComponent(path))
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      const arg =
        this.currentModule.name +
        "/" +
        this.currentModule.version +
        "/" +
        row.name +
        "/" +
        _location;

      let url = this.moduleUrl + "config/cat/" + arg;
      if (this.instanceid) {
        // url = this.baseUrl + 'config/cat/' + this.currentModule.name + "/"
        //   + this.currentModule.version + "/" + this.instanceid + '/'
        //   + row.name + "/" + _location;
        this.selectVersionPost(row, _location)
      } else {
        this.$axios.get(url).then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.anothercode = data;
            this.$nextTick(function () {
              this.initUI(this.nowCode, this.anothercode)
            });
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
          loading.close();
          console.log(err)
        });
      }
    },
    selectVersionPost(row, _location) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let data = {}
      let url = this.baseUrl3 + "config/cat/content"
      data = {
        instanceId: this.instanceid,
        configName: row.name,
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        location: _location+"",
        history: true
      }
      //远端
      if (this.type == '2') {
        url = this.baseUrl3 + 'config/cat/remote/content'
        // + this.instanceid + '/' + row.name + "/" + _location
        data = {
          instanceId: this.instanceid,
          configName: row.name,
          location: _location+""
        }
      }
      this.$axios.post(url, data).then(({data: {msg, data, code}}) => {
        if (code == 20000) {
          this.anothercode = data;
          this.$nextTick(function () {
            this.initUI(this.nowCode, this.anothercode)
          });
        } else {
          this.$message({showClose: true, message: msg, type: "error"});
          console.log(msg);
        }
        loading.close()
      }).catch(err => {
        loading.close();
        console.log(err)
      });
    },
    //配置文件列表-查看
    configDetail(row, flag) {
      // if (flag=="edit"){
      //   this.isShow=true;
      // }else {
      //   this.isShow=false;
      // }
      this.lineName = row.name;
      this.lineLocation = row.location;
      debugger
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // let path=this.allLocation;
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = this.lineLocation
      }
      const arg =
        this.currentModule.name +
        "/" +
        this.currentModule.version +
        "/" +
        row.name +
        "/" +
        encodeURIComponent(encodeURIComponent(path));
debugger
      let url = this.moduleUrl + "config/cat/" + arg;
      if (this.instanceid) {
        this.configDetailPost(row, path)
      } else {
        let that = this;
        this.$axios.get(url).then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.textContent = "";
              this.xmlShow = true;
              this.fileName = row.name;
              this.jiequ();
              this.textContent = data;
              this.code = this.textContent;
              this.initYaml();
              this.saveLocation = row.location;
            } else {
              this.$confirm('本地内容为空，是否从远端获取数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                that.configDetailRemote(row);
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
            }
          } else {
            this.$confirm('本地内容为空，是否从远端获取数据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.configDetailRemote(row);
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
            // this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
          loading.close();
          console.log(err)
        });
      }
    },
    configDetailPost(row, path) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // url = this.baseUrl + 'config/cat/' + this.currentModule.name + "/"
      //   + this.currentModule.version + "/" + this.instanceid + '/'
      //   + row.name + "/" + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + 'config/cat/content';
      let data = {
        instanceId: this.instanceid,
        configName: row.name,
        moduleName: this.currentModule.name,
        moduleVersion: this.currentModule.version,
        location: path+""
      }
      //远端
      if (this.type == '2') {
        url = this.baseUrl3 + 'config/cat/remote/content'
        // + this.instanceid + '/' + row.name + "/" + encodeURIComponent(encodeURIComponent(path))
        data = {
          instanceId: this.instanceid,
          configName: row.name,
          location: path+""
        }
      }
      let that = this;
      this.$axios.post(url, data).then(({data: {msg, data, code}}) => {
        if (code == 20000 && data) {
          this.textContent = "";
          this.xmlShow = true;
          this.fileName = row.name;
          this.jiequ();
          this.textContent = data;
          this.code = this.textContent;
          this.initYaml();
          this.saveLocation = row.location;
        } else if (this.type != '2') {
          this.$confirm('本地内容为空，是否从远端获取数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.configDetailRemote(row);
            return
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.$message({showClose: true, message: msg, type: "error"});
        }
        loading.close()
      }).catch(err => {
        loading.close();
        console.log(err)
      });
    },
    configDetailRemote(row) {
      // let loading = Loading.service({
      //   fullscreen: true,
      //   text: "数据加载中..."
      // });
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = row.location
      }
      // const arg =
      //   this.currentModule.name +
      //   "/" +
      //   this.currentModule.version +
      //   "/" +
      //   row.name +
      //   "/" +
      //   encodeURIComponent(encodeURIComponent(path));

      // let url = this.moduleUrl + "config/cat/" + arg;
      if (this.instanceid) {
        this.configDetailRemotePost(row, path)
      }
      // this.$axios.get(url)
      //   .then(({data: {msg, data, code}}) => {
      //     if (code == 20000) {
      //       this.textContent = "";
      //       this.xmlShow = true;
      //       this.fileName = row.name;
      //       this.jiequ();
      //       this.textContent = data;
      //       this.code = this.textContent;
      //       this.initYaml();
      //       this.saveLocation = row.location
      //     } else {
      //       this.$message({showClose: true, message: msg, type: "error"});
      //       console.log(msg);
      //     }
      //     loading.close()
      //   }).catch(err => {
      //   loading.close();
      //   console.log(err)
      // });
    },
    configDetailRemotePost(row, path) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let url = this.baseUrl3 + 'config/cat/remote/content'
      // + this.instanceid + '/' + row.name + "/" + encodeURIComponent(encodeURIComponent(path))

      let data = {
        configName: row.name,
        instanceId: this.instanceid,
        location: path+""
      }

      this.$axios.post(url, data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.textContent = "";
            this.xmlShow = true;
            this.fileName = row.name;
            this.jiequ();
            this.textContent = data;
            this.code = this.textContent;
            this.initYaml();
            this.saveLocation = row.location
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
        loading.close();
        console.log(err)
      });
    },
    //helper查看
    configDetailSH(command) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let newPath;
      if (this.showBack) {
        newPath = this.allLocation;
      } else {
        newPath = command.row.location
      }
      let model = {
        instanceId: this.instanceid,
        configName: command.row.name,
        configVersion: command.row.version ? command.row.version : "1.0.0",
        location: encodeURIComponent(encodeURIComponent(newPath))+"",
        codec: command.charset
      };
      this.$axios
        .post(this.baseUrl3 + 'config/helper/cat/content', model)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.xmlDialogVisible = true;
            this.fileName = command.row.name;
            this.xmlContentText = data;
          } else {
            this.xmlDialogVisible = false;
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
        loading.close();
        this.$message.error('请求失败！')
      });
    },
    upload(row) {
      this.currentXml = row;
    },
    // 文件上传
    handleSuccess({code, msg, data}, file, fileList) {
      if (code == 20000) {
        // this.unitForm.upload = data;
        this.configs.push({
          // moduleType: this.currentModule.name,
          upload: data,
          name: file.name
          // version: this.currentXml.version
        });
        this.$emit("uploadCallback", this.configs);
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败！原因：" + msg);
      }
    },
    handleError(err, file, fileList) {
      this.$message({showClose: true, message: "上传失败", type: "error"});
      console.log("error=" + err);
    },
    // 反向同步
    reverseSync(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let url = this.baseUrl3 + 'config/reverseSync'
      // + this.instanceid + '/' + row.name + '/' + encodeURIComponent(encodeURIComponent(row.location));
      let data = {
        instanceId: this.instanceid,
        configName: row.name,
        location: row.location+""
      }
      this.$axios
        .post(url, data)
        .then(({data: {msg, data, code}}) => {
          loading.close();
          if (code == 20000) {
            this.$message.success('操作成功')
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(errr => {
        loading.close();
        console.log(err)
      });
    },
    hotLoading(row) {
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        path = row.location
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let currentVersion = "";
      if (row.version) {
        currentVersion = row.version
      } else {
        currentVersion = "1.0.0";
      }
      let url = this.baseUrl3 + 'config/sync/hotLoading'
      // + this.instanceid + '/'+ row.name + '/' + currentVersion + '/' + encodeURIComponent(encodeURIComponent(path));

      let data = {
        instanceId: this.instanceid,
        configName: row.name,
        configVersion: currentVersion,
        location: path+""
      }
      this.$axios
        .post(url, data)
        .then(({data: {msg, data, code}}) => {
          loading.close();
          if (code == 20000) {
            this.$message.success('操作成功')
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(errr => {
        loading.close();
        console.log(err)
      });
    },
    coldLoading(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let path;
      if (this.docker) {
        path = this.allLocation
      } else {
        if (row.location == null) {
          path = null
        } else {
          path = row.location
        }
      }
      let url;
      let data;

      if (this.type == 1) {
        url = this.baseUrl3 + 'config/sync'
        // + this.instanceid + '/' + row.name + '/'+ encodeURIComponent(encodeURIComponent(path));
        data = {
          instanceId: this.instanceid,
          configName: row.name,
          location: path+""
        }
      } else if (this.type == 2) {
        url = this.baseUrl3 + 'config/sync'
        // + this.instanceid + '/' + this.lineName + '/'+ encodeURIComponent(encodeURIComponent(path));
        data = {
          instanceId: this.instanceid,
          configName: this.lineName,
          location: path+""
        }
      }
      this.$axios
        .post(url, data)
        .then(({data: {msg, data, code}}) => {
          loading.close();
          if (code == 20000) {
            if (this.start == 1) {
              this.$message({
                  duration: 0,
                  showClose: true,
                  message: `实例ID:` + this.instanceid + `  配置文件同步成功，但并未生效，需要重启服务！`,
                  type: 'error'
                }
              )
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          loading.close();
          console.log(err)
        });
    },
  }
};
</script>
<style scoped>
.history {
  left: 960px !important;
}

.left {
  display: inline-block;
  float: left;
  min-width: 300px;
}

.right {
  display: inline-block;
  float: left;
  min-width: 300px;
}

a {
  text-decoration: none;
  color: #fff;
}

.CodeMirror-hints {
  z-index: 3000 !important;
}

.CodeMirror-lint-tooltip {
  z-index: 3000 !important;
}

.code-mirror {
  font-size: 20px;
  line-height: 150%;
}

textarea {
  border: none;
  outline: none;
  box-shadow: none;
  resize: none;
}
</style>
